import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CommandPalette"] */ "/vercel/path0/src/components/command-palette/CommandPalette.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/PlausibleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionProvider"] */ "/vercel/path0/src/contexts/MotionContext.tsx");
